import * as React from 'react';
import './styles.scss';
import logo from 'client/assets/polco-logo-dark-text.svg';
import {
  MaterialIcon,
  MaterialIconName,
  AppLink,
} from 'client/shared/components/base';
import { ClientUrlUtils } from 'client/shared/core/helpers';
import { UserManagement } from '../user-management';
import { CurrentUser } from 'client/respondent/hooks';
import { SearchPublisherNav } from 'client/respondent/subscriptions/components/search-publisher/nav-search';
import { IconButton, Stack } from '@mui/material';
import { Sidebar, SideBarProps } from '../../components/sidebar';

export interface Props {
  readonly showMenu: boolean;
  readonly respondent: CurrentUser | null;
  readonly isGuest: boolean;
  readonly hideSideNavAuthButtons?: boolean;
}

const baseClass = 'pn-top-nav';

export const TopNav = (p: Props) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <header
        className={`${baseClass} pt-2 pb-2 border-bottom text-left px-4 shadow-sm sticky-top`}
      >
        {p.showMenu ? (
          <Stack alignItems={'center'} direction={'row'} gap={2} width={'100%'}>
            <IconButton onClick={() => setOpen(true)}>
              <MaterialIcon icon={MaterialIconName.MENU} />
            </IconButton>
            <Stack alignItems={'center'} flexGrow={1} justifyContent={'center'}>
              <AppLink
                className={`${baseClass}-link pl-2 mod-center`}
                noLineHeight
                to={ClientUrlUtils.respondent.feed.path()}
              >
                <img
                  alt="Polco Resident Homepage"
                  className={`${baseClass}-img`}
                  src={logo}
                />
              </AppLink>
            </Stack>
          </Stack>
        ) : (
          <Stack
            alignItems="center"
            direction="row"
            flexWrap={'wrap'}
            gap={1}
            justifyContent="space-between"
          >
            <AppLink
              className={`${baseClass}-link`}
              noLineHeight
              to={ClientUrlUtils.respondent.feed.path()}
            >
              <img
                alt="Polco Resident Homepage"
                className={`${baseClass}-img`}
                src={logo}
              />
            </AppLink>
            <SearchPublisherNav
              respondentId={p.respondent?.user?.respondent?.id ?? null}
            />
            <UserManagement isGuest={p.isGuest} respondent={p.respondent} />
          </Stack>
        )}
      </header>
      {p.showMenu && (
        <Sidebar
          {...SideBarProps.TRANSIENT({
            open,
            close: () => setOpen(false),
            isGuest: p.isGuest,
            respondent: p.respondent,
            hideAuthButtons: p.hideSideNavAuthButtons,
          })}
        ></Sidebar>
      )}
    </>
  );
};
